import { message } from "antd";
import { domainUrl } from "../../constants";
import { checkAuthorization } from "../../helpers";

const addEditBox = (data) => {  
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
    };
    const url = data.id ? '/updateIptvGoDevice' : '/addIptvGoDevice';
    return fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success('Iptv Go android box inserted successfully.');
                return 1;
            }
            throw result?.message;
        })
        .catch(error => {
            message.error(error);
            return 0;
        });
};

const addMultipleBoxes = (data) => {
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
    };
    return fetch(domainUrl + "/uploadMultipleIptvGoDevices", requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message);
                return 1;
            }
            throw result?.message;
        })
        .catch(error => {
            message.error(error);
            return 0;
        });
};

const addEditPortal = (data) => {  
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
    };
    const url = data.id ? '/updateIptvGoPortal' : '/addIptvGoPortal';
    return fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success('Iptv Go portal inserted successfully.');
                return 1;
            }
            throw result?.message;
        })
        .catch(error => {
            message.error(error);
            return 0;
        });
};

const deleteBox = (id) => {
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(domainUrl + `/deleteIptvGoDevice/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success('Iptv Go android box deleted successfully.');
                return 1;
            }
            throw result?.message;
        })
        .catch(error => {
            message.error(error);
            return 0;
        });
};

const deletePortal = (id) => {
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(domainUrl + `/deleteIptvGoPortal/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success('Iptv Go Portal deleted successfully.');
                return 1;
            }
            throw result?.message;
        })
        .catch(error => {
            message.error(error);
            return 0;
        });
};

// --- Free TV endpoints ---
const listLive = () => {
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(domainUrl + "/free-tv/live", requestOptions)
        .then(response => response.json())
        .catch(error => {
            message.error("Free TV list fetch failed");
            return { success: false };
        });
};

const updateCategoryStatus = (id, body) => {
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: JSON.stringify(body),
        redirect: 'follow'
    };
    return fetch(domainUrl + `/free-tv/category/${id}/status`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success('Kategori durumu güncellendi.');
            } else {
                message.error(result?.message || 'Güncelleme başarısız.');
            }
            return result;
        })
        .catch(error => {
            message.error("Kategori güncelleme hatası");
            return { success: false };
        });
};

const updateChannelStatus = (id, body) => {
    const {userToken} = checkAuthorization();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", userToken);
    const requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: JSON.stringify(body),
        redirect: 'follow'
    };
    return fetch(domainUrl + `/free-tv/channel/${id}/status`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success('Kanal durumu güncellendi.');
            } else {
                message.error(result?.message || 'Güncelleme başarısız.');
            }
            return result;
        })
        .catch(error => {
            message.error("Kanal güncelleme hatası");
            return { success: false };
        });
};

const boxManagementGo = {
    addEditBox,
    addMultipleBoxes,
    addEditPortal,
    deleteBox,
    deletePortal,
    listLive,
    updateCategoryStatus,
    updateChannelStatus
};

export { boxManagementGo };
